import * as DashboardConstants from "../../constants/DashboardConstants";
import {getByColName, resultSetSize} from "./DashBoardResultSetUtil";
import * as kendoThemeChooser from "../KednoThemeChooser";
import {calcChartTitle} from "../highCharts/HighGaugeDrawer";

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function createPieChart(userDashboardChartLine, h, w, is3D, widget, chartArea) {
    let params = userDashboardChartLine.parameters;
    let list = userDashboardChartLine.resultSet;
    let points = [];
    let j = 0;
    let labelParam = params[DashboardConstants.Param_Label];
    let valueParam = params[DashboardConstants.Param_Value];
    for (let i = 0; i < resultSetSize(list); i++) {
        let label = getByColName(i, labelParam, list);
        let pointValue = getByColName(i, valueParam, list);
        points[j] = {category: label, value: pointValue};
        j++;
    }
    let overLay = "none";
    if (is3D)
        overLay = "sharpBevel";
    widget.kendoChart({
        theme: kendoThemeChooser.currentTheme(),
        title: {
            text: calcChartTitle(userDashboardChartLine),
            padding: 15
        }, legend: {
            visible: false
        },
        series: [{
            type: "pie",
            data: points,
            overlay: {
                gradient: overLay
            }
        }],
        seriesDefaults: {
            labels: {
                visible: true,
                template: "#= category #: #= value#",
            }
        },
        chartArea: chartArea,
        tooltip: {
            visible: true,
            format: "{0}%",
            template: "#= category # <br> #= kendo.format('{0:p}', percentage) # "
        },

    });
    return widget;
}